<template>
  <div class="carousel"
    :data-align="alignment"
    :data-align_image="alignmentImage">
    <Carousel
      :loop="true"
      :perPage="1"
      :mouseDrag="true"
      :navigateTo="carouselCurrent"
      :paginationPadding="4"
      :paginationActiveColor="'rgba(30,30,30,0.7)'"
      :paginationColor="'rgba(200,200,200,0.7)'"
      @pageChange="carouselActivePage">
      <Slide v-for="(slide, index) in item.value" :key="index">
        <div v-if="slide.value" class="carouselImg imgFrame" :style="imgRadius">
          <div v-if="slide.dimmer" :style="{backgroundColor: slide.dimmer}" class="dimmer"></div>
          <img :src="slide.value" alt="" />
        </div>
        <div class="editCarousel">
          <label v-if="item.value.length > 1" class="btnEditCarousel uploadImg changeImg">
            <input type="file" @change="uploadImage(item, $event)">
          </label>
          <button type="button" class="btnEditCarousel btnLink" @click.stop="setSlideDetail(slide, item.value, index)"></button>
          <button type="button" class="btnEditCarousel btnDimmer" @click="colorPicker($event, slide)">
            <i class="bg"></i>
            <i :style="{backgroundColor: slide.dimmer}"></i>
          </button>
          <div class="enlargeImg btnEditCarousel">
            <input type="checkbox" :id="`enlarge_img_${id}_${item.columnId}_${index}`" :checked="slide.enlarge" @change="enlargeImage(index, $event)">
            <label :for="`enlarge_img_${id}_${item.columnId}_${index}`"></label>
          </div>
          <button type="button" class="btnEditCarousel btnDel" @click.stop="delSlide(slide, item.value, index)"></button>
        </div>
      </Slide>
    </Carousel>
    <div class="colorPreset">
      <sketch-picker style="display: none"
        :value="currentColor"
        @input="settingColor" />
    </div>
    <div v-if="isColorPicker" class="preventBox" @click="hideColorPicker"></div>
    <div class="btnCarousel" :class="{mt5: item.value.length > 1, hasCarousel: item.value.length > 1}">
      <label class="uploadImg">
        <input type="file" @change="addImage(item, $event)">
      </label>
      <!-- <label v-if="item.value.length > 1" class="uploadImg changeImg">
        <input type="file" @change="uploadImage(item, $event)">
      </label> -->
      <button type="button" class="btn btnGrey imageOrder"
         v-if="item.value.length > 2"
        @click="changeOrder">
        {{locale.change_order}}
      </button>
      <div v-if="changeImageOrder" class="orderBox">
        <button type="button" class="closeImageOrder" @click="changeOrder"></button>
        <draggable class="orderList"
          v-model="orderList"
          :animation="200">
          <div class="orderItem"
            v-for="(img, index) in orderList"
            :key="index">
            <span class="index">{{index + 1}}</span>
            <img v-if="img.value !== ''" :src="img.value" alt="">
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import draggable from 'vuedraggable'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import sketch from 'vue-color/src/components/Sketch.vue'

export default {
  name: 'CarouselModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  components: {
    Carousel,
    Slide,
    draggable,
    'sketch-picker': sketch
  },
  computed: {
    alignment () {
      return this.item.detail.carousel.alignment
    },
    alignmentImage () {
      return this.item.detail.carousel.alignmentImage
    },
    orderList: {
      get () {
        const value = this.item.value
        return value.length === 1 ? value : value.filter((x, i) => i !== value.length - 1)
      },
      set (val) {
        const value = this.item.value
        const last = value.filter((x, i) => i === value.length - 1)
        this.item.value = val.concat(last)
      }
    },
    dimmer () {
      const i = this.carouselCurrent
      return this.item.value[i].dimmer || this.currentColor
    },
    imgRadius () {
      const detail = this.item.detail.radius && this.item.detail.radius.active ? this.item.detail.radius : null
      const radius = detail ? `${detail.tl}px ${detail.tr}px ${detail.br}px ${detail.bl}px` : null
      return `border-radius: ${radius}`
    }
  },
  data () {
    return {
      carouselCurrent: 0,
      changeImageOrder: false,
      isColorPicker: false,
      transparent: 'rgba(255, 255, 255, 0)',
      currentColor: ''
    }
  },
  methods: {
    carouselActivePage (p) {
      this.carouselCurrent = p
      // this.currentColor = this.item.value[p].dimmer || this.transparent
    },
    delSlide (slide, item, index) {
      if (window.confirm(this.locale.confirm_delete_image)) {
        // this.$store.commit('util/removeUploadFiles', slide.dataId)
        item.splice(index, 1)
      }
    },
    setSlideDetail (slide) {
      const langValue = this.$store.state.setting.lang.langValue
      const detail = {
        options: ['link'],
        link: {
          type: 'page',
          url: Object.assign({}, langValue),
          pageId: '',
          target: false
        }
      }
      if (!!slide.link && slide.link !== null) {
        detail.link = slide.link
      } else {
        slide.link = detail.link
      }
      this.$emit('setDetail', detail)
    },
    addImage (item, e) {
      if (item.value.length > 1) {
        this.carouselCurrent = item.value.length - 1
      }
      this.uploadImage(item, e)
    },
    uploadImage (item, e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = data.file && regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          const carouselIndex = this.carouselCurrent
          const carouselItem = item.value[carouselIndex]
          if (typeof (carouselItem.value) === 'undefined' || carouselItem.value === '') {
            item.value.push({
              value: ''
            })
          }
          carouselItem.value = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    changeOrder () {
      this.changeImageOrder = !this.changeImageOrder
    },
    settingColor (c) {
      const i = this.carouselCurrent
      const rgba = `rgba(${c.rgba.r}, ${c.rgba.g}, ${c.rgba.b}, ${c.rgba.a})`
      this.currentColor = rgba
      this.item.value[i].dimmer = rgba
    },
    colorPicker: function (e, item) {
      this.isColorPicker = true
      this.currentColor = item.dimmer || this.transparent
      document.querySelectorAll('.vc-sketch').forEach(x => {
        x.style.display = 'none'
      })
      e.currentTarget.closest('.carousel').querySelector('.colorPreset').classList.add('active')
      e.currentTarget.closest('.carousel').querySelector('.vc-sketch').style.display = 'block'
      document.addEventListener('click', this.hideColorPicker)
    },
    hideColorPicker: function (e) {
      this.isColorPicker = false
      document.querySelectorAll('.colorPreset').forEach(x => {
        x.classList.remove('active')
      })
      document.querySelectorAll('.vc-sketch').forEach(x => {
        x.style.display = 'none'
      })
      document.removeEventListener('click', this.hideColorPicker)
    },
    enlargeImage (index, e) {
      const isEnlarge = e.target.checked
      this.item.value[index].enlarge = isEnlarge
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel {
  position: relative;
}
.preventBox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.colorPreset {
  border: none;
  .vc-sketch {
    right: auto;
    left: 50%;
    margin-left: -100px;
  }
}
.btnCarousel {
  display: flex;
  position: relative;
  .uploadImg {
    flex: 1;
    position: relative;
    height: 3.2em;
    border: 1px solid $color-lgrey2;
    background-color: $bg-default;
    cursor: pointer;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20%;
      height: 20%;
      min-width: 36px;
      min-height: 36px;
      background: url('~@/assets/img/ico_upload_image.png') 50% 50% / contain no-repeat;
      transform: translate(-50%, -50%);
      opacity: 0.3;
    }
  }
  .imageOrder {
    flex: 1;
    margin-left: 5px;
  }
}
.orderBox {
  position: fixed;
  top: 50%;
  left: 50%;
  padding: 30px;
  border: 10px solid $color-black;
  background-color: $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.15);
  transform: translate(-50%, -50%);
  .closeImageOrder {
    position: absolute;
    top: -10px;
    left: 100%;
    width: 45px;
    height: 45px;
    margin-left: 10px;
    background-color: $color-black;
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -1px;
      margin-left: -12px;
      width: 24px;
      height: 2px;
      background-color: $color-white;
      transform: rotate(45deg);
      transform-origin: 50% 50%;
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
  .orderList {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 416px;
  }
  .orderItem {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100px;
    height: 100px;
    margin: 2px;
    border: 1px dashed $color-lgrey;
    cursor: move;
    .index {
      position: absolute;
      top: 2px;
      left: 2px;
      min-width: 14px;
      height: 14px;
      text-align: center;
      font-size: 12px;
      line-height: 14px;
      color: $color-white;
      border-radius: 100%;
      background-color: rgba(0,0,0,0.5);
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
